/**
* Graphic Photo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Graphic Photo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'graphic-photo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.graphic-photo-marquee' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--graphic-photo-marquee' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '32px',
          autoWidth: true,
          direction: window.isRtl ? 'rtl' : 'ltr',
        } );

        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'graphic-photo-marquee', COMPONENT );
} )( app );
